import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {LocalStorageService} from "../../services/local-storage.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {DebounceKeyupDirective} from "../../directives/debounce-keyup.directive";
import {RouterLink} from "@angular/router";
import {StatusPipe} from "../../pipes/status.pipe";
import {DatePipe, NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-archive',
    templateUrl: './archive.component.html',
    imports: [
        PaginationComponent,
        FormsModule,
        DebounceKeyupDirective,
        RouterLink,
        StatusPipe,
        DatePipe,
        NgIf,
        NgForOf
    ],
    styleUrl: './archive.component.scss'
})
export class ArchiveComponent implements OnInit {

    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;
    departments: any[];
    tasktypes: any[];

    ngOnInit(): void {

        this.search = {
            title: '',
            status: 'all',
            customer: '',
            id_department: 'all',
            id_tasktype: 'all',
        };

        let searchSaved = this.localStorageService.getItem('archive-list');
        if (searchSaved) {
            this.search = {...this.search, ...searchSaved}
        }

        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = false;
        this.totalEntries = 0;
        this.predicate = 'created_at';
        this.listEntries(this.paginConfig);

        this.dataService.request('Department/listForUser').subscribe(response => {
            this.departments = response.departments;
        });

        this.dataService.request('Tasktype/listForLists').subscribe(response => {
            this.tasktypes = response.tasktypes;
        });
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.localStorageService.setItem('archive-list', this.search);

        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Task/listArchived', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            search: this.search,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.tasks;
        });
    }

}
